import React from "react";
import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./LoginForm.type";
import { AppNotifications, RootState } from "../../../models";
import { withRouter } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import { NotificationActions } from "../../../store/actions";
import { connect } from "react-redux";
import LoginFormPresenter from "./LoginForm.presenter";
import { AuthService } from "../../../services";
import { loadCallback } from "../../../utils";
class LoginFormContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  onSignInByGoogle = () => {
    this.setState({ loading: true });
  };

  onSignInByFacebook = () => {
    this.setState({ loading: true });
  };

  onShowMessForSigninFail = () => {
    this.props.actions.enqueueSnackbar({
      type: AppNotifications.ERROR,
      message: "Invalid user name or password",
    });
  };

  onSignin = (values) => {
    AuthService.signIn(values)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Successfully Logged in",
          });
          loadCallback(this.props.onSigninSuccess, res.data);
        } else if (res && res.status === 404) {
          if (res.data.message === "EMPLOYEE_NOT_EXIST") {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Invalid user name or password",
            });
          } else {
            this.onShowMessForSigninFail();
          }
        } else if (res && res.status === 400) {
          if (res.data.message === "INCORRECT_PASSWORD") {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Invalid user name or password",
            });
          } else {
            this.onShowMessForSigninFail();
          }
        } else {
          this.onShowMessForSigninFail();
        }
      })
      .catch((err) => {
        this.onShowMessForSigninFail();
      });
  };

  render() {
    return (
      <>
        <LoginFormPresenter
          {...this.props}
          {...this.state}
          onSignInByGoogle={this.onSignInByGoogle}
          onSignInByFacebook={this.onSignInByFacebook}
          onSignin={this.onSignin}
        />
      </>
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(LoginFormContainer)
);
